import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Components, ProductFamily } from '../../common/interfaces';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { parseMarkedDownText } from '../../utils/ContentUtil';
import { ValuePropsContainer, HeaderContainer, Footer } from './styled';
import { Strings } from './strings';
import { CheckList } from '@chegg-ui/list';
import { colors } from '@chegg-ui/theme';
import { StudyIcon, StudyPackIcon, MathSolverIcon } from '@chegg-ui/horizon-icons';
var ValueProps = function ValueProps(_ref) {
  var content = _ref.content,
    onError = _ref.onError,
    headingLevel = _ref.headingLevel,
    hideIcon = _ref.hideIcon;
  if (!content) return null;
  if (!content.line1 || !content.items.length) {
    onError(getErrorMessage(Components.VALUE_PROPS, Strings.MISSING_CONTENT_ERROR));
    return null;
  }
  var parseListItems = function parseListItems(items) {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: "vp-li-".concat(index),
        dangerouslySetInnerHTML: parseMarkedDownText(item),
        className: 'vp-list-item'
      });
    });
  };
  var listItems = parseListItems(content.items);
  var productFamily = content.productFamily;
  var header = content.line1;
  var footer = content.line2;
  var footer2 = content.footer2;
  var commonIconProps = {
    size: 'medium',
    color: colors.cheggOrange,
    className: 'PRODUCT_ICON',
    'aria-hidden': true
  };
  var determineIconToShow = function determineIconToShow(productFamily) {
    var icon;
    if (productFamily === ProductFamily.CHEGG_STUDY) {
      icon = /*#__PURE__*/React.createElement(StudyIcon, _extends({
        "data-test": 'STUDY-ICON'
      }, commonIconProps));
    } else if (productFamily === ProductFamily.BUNDLE) {
      icon = /*#__PURE__*/React.createElement(StudyPackIcon, _extends({
        "data-test": 'STUDY-PACK-ICON'
      }, commonIconProps));
    } else if (productFamily === ProductFamily.CHEGG_MATH) {
      icon = /*#__PURE__*/React.createElement(MathSolverIcon, _extends({
        "data-test": 'MATH-SOLVER-ICON'
      }, commonIconProps));
    }
    return icon;
  };
  return /*#__PURE__*/React.createElement(ValuePropsContainer, null, /*#__PURE__*/React.createElement(HeaderContainer, {
    showIcon: !!productFamily
  }, productFamily && !hideIcon && determineIconToShow(productFamily), /*#__PURE__*/React.createElement("h2", {
    "aria-level": headingLevel,
    "data-test": 'VP-HEADER'
  }, header)), /*#__PURE__*/React.createElement(CheckList, {
    "data-test": 'VP-LIST',
    items: listItems,
    color: 'cheggOrange',
    align: 'top',
    size: 'md'
  }), footer && /*#__PURE__*/React.createElement(Footer, {
    "data-test": 'VP-FOOTER'
  }, footer), footer2 && /*#__PURE__*/React.createElement(Footer, {
    "data-test": 'VP-FOOTER2'
  }, footer2));
};
export default /*#__PURE__*/React.memo(ValueProps);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ValuePropositions/index.js
// module id = 4045
// module chunks = 11